import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { Deal } from '../../models/deals.model';
import { MatIconModule } from '@angular/material/icon';
import { provideNativeDateAdapter } from '@angular/material/core';
import { DealService } from '../../services/deal.service';
import { HousingService } from '../../services/housing.service';
import { JobService } from '../../services/job.service';
import { Post } from '../../models/post.model';
import { PostService } from '../../services/post.service';
import { MatButtonModule } from '@angular/material/button';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTabGroup, MatTabsModule } from '@angular/material/tabs';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DealTypes, StatusValues } from '../../constants';

@Component({
  selector: 'app-admin-view-listings',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatIconModule,
    MatButtonModule,
    MatSlideToggleModule,
    MatTabGroup,
    MatTabsModule,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: './admin-view-listings.component.html',
  styleUrl: './admin-view-listings.component.scss'
})
export class AdminViewListingsComponent implements OnInit {
  deals: Deal[] = [];
  apartmentsAndHousing: Deal[] = [];
  jobsAndInternships: Deal[] = [];
  posts: Post[] = [];
  
  showComments: boolean = false;
  commentSectionPostId: string = '';
  queryParams = new Map<string, any>();

  constructor(
    private dealService: DealService,
    private housingService: HousingService,
    private jobService: JobService,
    private postService: PostService,
    private snackBar: MatSnackBar,
  ) {}

  ngOnInit(): void {
    this.getAllDeals();
    this.getAllHousing();
    this.getAllJobs();
    this.getAllPosts();
  }

  getAllDeals() {
    this.queryParams.set('DealType', DealTypes.Deal);
    this.queryParams.set('Status', StatusValues.All);
    
    this.dealService.getAllDeals(this.queryParams).subscribe({
      next: (response: Deal[]) => {
        this.deals = response;
      }
    });
  }

  getAllHousing() {
    this.queryParams.set('DealType', DealTypes.Housing);
    this.queryParams.set('Status', StatusValues.All);

    this.housingService.getAllHousing(this.queryParams).subscribe({
      next: (response: Deal[]) => {
        this.apartmentsAndHousing = response;
      }
    });
  }

  getAllJobs() {
    this.queryParams.set('DealType', DealTypes.Job);
    this.queryParams.set('Status', StatusValues.All);
    
    this.jobService.getAllJobs(this.queryParams).subscribe({
      next: (response: Deal[]) => {
        this.jobsAndInternships = response;
      }
    });
  }

  getAllPosts() {
    this.queryParams.set('Status', StatusValues.All);

    this.postService.getAllPosts(this.queryParams).subscribe({
      next: (response: Post[]) => {
        this.posts = response;
      },
    });
  }

  viewComments(postId: string) {
    this.showComments = !this.showComments;

    if (this.commentSectionPostId != postId) {
      this.commentSectionPostId = postId;
      this.showComments = true;
    }
  }

  toggleDealStatus(deal: Deal) {
    deal.status = this.switchActiveInactive(deal.status);

    this.dealService.updateDeal(deal).subscribe({
      next: () => {
        this.snackBar.open(
          'Updated',
          '',
          { duration: 3000 }
        );
      },
      error: () => {
        this.snackBar.open(
          'An error has occurred. Please try again.',
          '',
          { duration: 3000 }
        );
      }
    });
  }

  togglePostStatus(post: Post) {
    post.status = this.switchActiveInactive(post.status ? post.status : "INACTIVE");

    this.postService.updatePost(post).subscribe({
      next: () => {
        this.snackBar.open(
          'Updated',
          '',
          { duration: 3000 }
        );
      },
      error: () => {
        this.snackBar.open(
          'An error has occurred. Please try again.',
          '',
          { duration: 3000 }
        );
      }
    });
  }

  switchActiveInactive(status: string) {
    if (status == "ACTIVE") {
      return "INACTIVE";
    } else {
      return "ACTIVE";
    }
  }
}
